// extracted by mini-css-extract-plugin
module.exports = {"__sidebar_my_powers_title":"myPowers___sidebar_my_powers_title__CUXL2","__sidebar_my_powers":"myPowers___sidebar_my_powers__2aMni"};